// import { useState } from 'react';
// import { Book, Code, Copy, Check, Link as LinkIcon } from 'lucide-react';
// import { toast } from 'sonner';
// import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
// import { Button } from '@/components/ui/button';
// import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

// const ApiDocsPage = () => {
//   const [copied, setCopied] = useState('');

//   const copyToClipboard = (text, id) => {
//     navigator.clipboard.writeText(text);
//     setCopied(id);
//     toast.success('Disalin ke clipboard');
//     setTimeout(() => setCopied(''), 2000);
//   };

//   const user = JSON.parse(localStorage.getItem('user') || '{}');
//   const apiKey = user.apiKey || 'YOUR_API_KEY';

//   const curlExample = `curl -X POST "${API}/public/send-message" \\
//   -H "Content-Type: application/json" \\
//   -d '{
//     "phone": "628123456789",
//     "message": "Hello from API",
//     "apiKey": "${apiKey}"
//   }'`;

//   const pythonExample = `import requests

// url = "${API}/public/send-message"
// payload = {
//     "phone": "628123456789",
//     "message": "Hello from Python",
//     "apiKey": "${apiKey}"
// }

// response = requests.post(url, json=payload)
// print(response.json())`;

//   const javascriptExample = `const axios = require('axios');

// const sendMessage = async () => {
//   try {
//     const response = await axios.post('${API}/public/send-message', {
//       phone: '628123456789',
//       message: 'Hello from JavaScript',
//       apiKey: '${apiKey}'
//     });
//     console.log(response.data);
//   } catch (error) {
//     console.error(error.response.data);
//   }
// };

// sendMessage();`;

//   const phpExample = `<?php
// $url = "${API}/public/send-message";
// $data = array(
//     "phone" => "628123456789",
//     "message" => "Hello from PHP",
//     "apiKey" => "${apiKey}"
// );

// $options = array(
//     'http' => array(
//         'method'  => 'POST',
//         'header'  => 'Content-Type: application/json',
//         'content' => json_encode($data)
//     )
// );

// $context = stream_context_create($options);
// $result = file_get_contents($url, false, $context);
// echo $result;
// ?>`;

//   return (
//     <div className="space-y-6">
//       {/* Header */}
//       <div>
//         <h1 className="text-4xl md:text-5xl font-bold text-gray-800">API Documentation</h1>
//         <p className="text-gray-600 mt-2">Dokumentasi lengkap untuk integrasi WhatsApp API</p>
//       </div>

//       {/* API Endpoint */}
//       <Card className="glass-effect">
//         <CardHeader>
//           <CardTitle className="flex items-center gap-2">
//             <LinkIcon className="text-green-600" size={24} />
//             API Endpoint
//           </CardTitle>
//         </CardHeader>
//         <CardContent>
//           <div className="bg-gray-900 text-green-400 p-4 rounded-lg font-mono text-sm flex items-center justify-between">
//             <span>{API}/public/send-message</span>
//             <Button
//               size="sm"
//               variant="ghost"
//               onClick={() => copyToClipboard(`${API}/public/send-message`, 'endpoint')}
//               className="text-green-400 hover:text-green-300 hover:bg-gray-800"
//             >
//               {copied === 'endpoint' ? <Check size={16} /> : <Copy size={16} />}
//             </Button>
//           </div>
//         </CardContent>
//       </Card>

//       {/* Authentication */}
//       <Card className="glass-effect">
//         <CardHeader>
//           <CardTitle>Authentication</CardTitle>
//           <CardDescription>
//             Gunakan API Key Anda untuk autentikasi. API Key bisa ditemukan di halaman Settings.
//           </CardDescription>
//         </CardHeader>
//         <CardContent>
//           <div className="space-y-2">
//             <p className="font-semibold">Your API Key:</p>
//             <div className="bg-gray-900 text-green-400 p-3 rounded-lg font-mono text-sm flex items-center justify-between">
//               <span>{apiKey}</span>
//               <Button
//                 size="sm"
//                 variant="ghost"
//                 onClick={() => copyToClipboard(apiKey, 'apikey')}
//                 className="text-green-400 hover:text-green-300 hover:bg-gray-800"
//               >
//                 {copied === 'apikey' ? <Check size={16} /> : <Copy size={16} />}
//               </Button>
//             </div>
//           </div>
//         </CardContent>
//       </Card>

//       {/* Request Format */}
//       <Card className="glass-effect">
//         <CardHeader>
//           <CardTitle>Request Format</CardTitle>
//         </CardHeader>
//         <CardContent>
//           <div className="space-y-4">
//             <div>
//               <p className="font-semibold mb-2">Method:</p>
//               <code className="bg-gray-100 px-3 py-1 rounded">POST</code>
//             </div>
//             <div>
//               <p className="font-semibold mb-2">Content-Type:</p>
//               <code className="bg-gray-100 px-3 py-1 rounded">application/json</code>
//             </div>
//             <div>
//               <p className="font-semibold mb-2">Body Parameters:</p>
//               <div className="bg-gray-50 p-4 rounded-lg border space-y-2">
//                 <div className="flex items-start gap-2">
//                   <code className="text-blue-600 font-mono">phone</code>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm">string</span>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm text-red-600">required</span>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm text-gray-600">Format: 628xxx (tanpa +)</span>
//                 </div>
//                 <div className="flex items-start gap-2">
//                   <code className="text-blue-600 font-mono">message</code>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm">string</span>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm text-red-600">required</span>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm text-gray-600">Teks pesan yang akan dikirim</span>
//                 </div>
//                 <div className="flex items-start gap-2">
//                   <code className="text-blue-600 font-mono">apiKey</code>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm">string</span>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm text-red-600">required</span>
//                   <span className="text-gray-500">|</span>
//                   <span className="text-sm text-gray-600">API Key Anda</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </CardContent>
//       </Card>

//       {/* Response Format */}
//       <Card className="glass-effect">
//         <CardHeader>
//           <CardTitle>Response Format</CardTitle>
//         </CardHeader>
//         <CardContent>
//           <Tabs defaultValue="success">
//             <TabsList>
//               <TabsTrigger value="success">Success (200)</TabsTrigger>
//               <TabsTrigger value="error">Error (4xx/5xx)</TabsTrigger>
//             </TabsList>
//             <TabsContent value="success">
//               <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
// {`{
//   "success": true,
//   "message": "Message sent",
//   "data": {
//     "userId": "user_id",
//     "id": "message_id",
//     "to": "628123456789",
//     "timestamp": "2024-01-01T00:00:00Z",
//     "type": "sent",
//     "content": "Hello from API",
//     "mediaType": "text",
//     "status": "sent"
//   }
// }`}
//               </pre>
//             </TabsContent>
//             <TabsContent value="error">
//               <pre className="bg-gray-900 text-red-400 p-4 rounded-lg overflow-x-auto text-sm">
// {`{
//   "detail": "Error message here"
// }`}
//               </pre>
//               <div className="mt-4 space-y-2 text-sm">
//                 <p><strong>401:</strong> Invalid API key</p>
//                 <p><strong>400:</strong> WhatsApp not connected / Invalid parameters</p>
//                 <p><strong>500:</strong> Server error</p>
//               </div>
//             </TabsContent>
//           </Tabs>
//         </CardContent>
//       </Card>

//       {/* Code Examples */}
//       <Card className="glass-effect">
//         <CardHeader>
//           <CardTitle className="flex items-center gap-2">
//             <Code className="text-green-600" size={24} />
//             Code Examples
//           </CardTitle>
//         </CardHeader>
//         <CardContent>
//           <Tabs defaultValue="curl">
//             <TabsList className="grid grid-cols-4 w-full">
//               <TabsTrigger value="curl">cURL</TabsTrigger>
//               <TabsTrigger value="python">Python</TabsTrigger>
//               <TabsTrigger value="javascript">Node.js</TabsTrigger>
//               <TabsTrigger value="php">PHP</TabsTrigger>
//             </TabsList>

//             <TabsContent value="curl">
//               <div className="relative">
//                 <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
//                   {curlExample}
//                 </pre>
//                 <Button
//                   size="sm"
//                   variant="ghost"
//                   onClick={() => copyToClipboard(curlExample, 'curl')}
//                   className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
//                 >
//                   {copied === 'curl' ? <Check size={16} /> : <Copy size={16} />}
//                 </Button>
//               </div>
//             </TabsContent>

//             <TabsContent value="python">
//               <div className="relative">
//                 <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
//                   {pythonExample}
//                 </pre>
//                 <Button
//                   size="sm"
//                   variant="ghost"
//                   onClick={() => copyToClipboard(pythonExample, 'python')}
//                   className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
//                 >
//                   {copied === 'python' ? <Check size={16} /> : <Copy size={16} />}
//                 </Button>
//               </div>
//             </TabsContent>

//             <TabsContent value="javascript">
//               <div className="relative">
//                 <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
//                   {javascriptExample}
//                 </pre>
//                 <Button
//                   size="sm"
//                   variant="ghost"
//                   onClick={() => copyToClipboard(javascriptExample, 'javascript')}
//                   className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
//                 >
//                   {copied === 'javascript' ? <Check size={16} /> : <Copy size={16} />}
//                 </Button>
//               </div>
//             </TabsContent>

//             <TabsContent value="php">
//               <div className="relative">
//                 <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
//                   {phpExample}
//                 </pre>
//                 <Button
//                   size="sm"
//                   variant="ghost"
//                   onClick={() => copyToClipboard(phpExample, 'php')}
//                   className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
//                 >
//                   {copied === 'php' ? <Check size={16} /> : <Copy size={16} />}
//                 </Button>
//               </div>
//             </TabsContent>
//           </Tabs>
//         </CardContent>
//       </Card>

//       {/* Rate Limits */}
//       <Card className="glass-effect">
//         <CardHeader>
//           <CardTitle>Rate Limits & Best Practices</CardTitle>
//         </CardHeader>
//         <CardContent>
//           <ul className="space-y-2 text-gray-700">
//             <li className="flex items-start gap-2">
//               <span className="text-green-600 mt-1">•</span>
//               <span>Pastikan WhatsApp Anda terhubung sebelum mengirim pesan</span>
//             </li>
//             <li className="flex items-start gap-2">
//               <span className="text-green-600 mt-1">•</span>
//               <span>Format nomor harus 628xxx (kode negara Indonesia tanpa +)</span>
//             </li>
//             <li className="flex items-start gap-2">
//               <span className="text-green-600 mt-1">•</span>
//               <span>Simpan API key dengan aman, jangan share ke publik</span>
//             </li>
//             <li className="flex items-start gap-2">
//               <span className="text-green-600 mt-1">•</span>
//               <span>Implementasikan error handling untuk request yang gagal</span>
//             </li>
//             <li className="flex items-start gap-2">
//               <span className="text-green-600 mt-1">•</span>
//               <span>Gunakan webhook untuk menerima pesan masuk secara real-time</span>
//             </li>
//           </ul>
//         </CardContent>
//       </Card>
//     </div>
//   );
// };

// export default ApiDocsPage;

import { useState } from 'react';
import { Book, Code, Copy, Check, Link as LinkIcon } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const WA_SERVICE_URL = process.env.REACT_APP_WA_SERVICE_URL
const API = `${BACKEND_URL}/api`;

const ApiDocsPage = () => {
  const [copied, setCopied] = useState('');

  const copyToClipboard = (text, id) => {
    navigator.clipboard.writeText(text);
    setCopied(id);
    toast.success('Disalin ke clipboard');
    setTimeout(() => setCopied(''), 2000);
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const apiKey = user.apiKey || 'YOUR_API_KEY';

  const curlExample = `curl -X POST "${API}/public/send-message" \\
  -H "Content-Type: application/json" \\
  -d '{
    "phone": "628123456789",
    "message": "Hello from API",
    "apiKey": "${apiKey}"
  }'`;

  const pythonExample = `import requests

url = "${API}/public/send-message"
payload = {
    "phone": "628123456789",
    "message": "Hello from Python",
    "apiKey": "${apiKey}"
}

response = requests.post(url, json=payload)
print(response.json())`;

  const javascriptExample = `const axios = require('axios');

const sendMessage = async () => {
  try {
    const response = await axios.post('${API}/public/send-message', {
      phone: '628123456789',
      message: 'Hello from JavaScript',
      apiKey: '${apiKey}'
    });
    console.log(response.data);
  } catch (error) {
    console.error(error.response.data);
  }
};

sendMessage();`;

  const phpExample = `<?php
$url = "${API}/public/send-message";
$data = array(
    "phone" => "628123456789",
    "message" => "Hello from PHP",
    "apiKey" => "${apiKey}"
);

$options = array(
    'http' => array(
        'method'  => 'POST',
        'header'  => 'Content-Type: application/json',
        'content' => json_encode($data)
    )
);

$context = stream_context_create($options);
$result = file_get_contents($url, false, $context);
echo $result;
?>`;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800">API Documentation</h1>
        <p className="text-gray-600 mt-2">Dokumentasi lengkap untuk integrasi WhatsApp API</p>
      </div>

      {/* API Endpoint */}
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <LinkIcon className="text-green-600" size={24} />
            API Endpoint
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="bg-gray-900 text-green-400 p-4 rounded-lg font-mono text-sm flex items-center justify-between">
            <span>{API}/public/send-message</span>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => copyToClipboard(`${API}/public/send-message`, 'endpoint')}
              className="text-green-400 hover:text-green-300 hover:bg-gray-800"
            >
              {copied === 'endpoint' ? <Check size={16} /> : <Copy size={16} />}
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Authentication */}
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle>Authentication</CardTitle>
          <CardDescription>
            Gunakan API Key Anda untuk autentikasi. API Key bisa ditemukan di halaman Settings.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <p className="font-semibold">Your API Key:</p>
            <div className="bg-gray-900 text-green-400 p-3 rounded-lg font-mono text-sm flex items-center justify-between">
              <span>{apiKey}</span>
              <Button
                size="sm"
                variant="ghost"
                onClick={() => copyToClipboard(apiKey, 'apikey')}
                className="text-green-400 hover:text-green-300 hover:bg-gray-800"
              >
                {copied === 'apikey' ? <Check size={16} /> : <Copy size={16} />}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Request Format */}
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle>Request Format</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div>
              <p className="font-semibold mb-2">Method:</p>
              <code className="bg-gray-100 px-3 py-1 rounded">POST</code>
            </div>
            <div>
              <p className="font-semibold mb-2">Content-Type:</p>
              <code className="bg-gray-100 px-3 py-1 rounded">application/json</code>
            </div>
            <div>
              <p className="font-semibold mb-2">Body Parameters:</p>
              <div className="bg-gray-50 p-4 rounded-lg border space-y-2">
                <div className="flex items-start gap-2">
                  <code className="text-blue-600 font-mono">phone</code>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm">string</span>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm text-red-600">required</span>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm text-gray-600">Format: 628xxx (tanpa +)</span>
                </div>
                <div className="flex items-start gap-2">
                  <code className="text-blue-600 font-mono">message</code>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm">string</span>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm text-red-600">required</span>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm text-gray-600">Teks pesan yang akan dikirim</span>
                </div>
                <div className="flex items-start gap-2">
                  <code className="text-blue-600 font-mono">apiKey</code>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm">string</span>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm text-red-600">required</span>
                  <span className="text-gray-500">|</span>
                  <span className="text-sm text-gray-600">API Key Anda</span>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Response Format */}
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle>Response Format</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="success">
            <TabsList>
              <TabsTrigger value="success">Success (200)</TabsTrigger>
              <TabsTrigger value="error">Error (4xx/5xx)</TabsTrigger>
            </TabsList>
            <TabsContent value="success">
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "success": true,
  "message": "Message sent",
  "data": {
    "userId": "user_id",
    "id": "message_id",
    "to": "628123456789",
    "timestamp": "2024-01-01T00:00:00Z",
    "type": "sent",
    "content": "Hello from API",
    "mediaType": "text",
    "status": "sent"
  }
}`}
              </pre>
            </TabsContent>
            <TabsContent value="error">
              <pre className="bg-gray-900 text-red-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "detail": "Error message here"
}`}
              </pre>
              <div className="mt-4 space-y-2 text-sm">
                <p><strong>401:</strong> Invalid API key</p>
                <p><strong>400:</strong> WhatsApp not connected / Invalid parameters</p>
                <p><strong>500:</strong> Server error</p>
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>

      {/* Code Examples */}
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Code className="text-green-600" size={24} />
            Code Examples
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs defaultValue="curl">
            <TabsList className="grid grid-cols-4 w-full">
              <TabsTrigger value="curl">cURL</TabsTrigger>
              <TabsTrigger value="python">Python</TabsTrigger>
              <TabsTrigger value="javascript">Node.js</TabsTrigger>
              <TabsTrigger value="php">PHP</TabsTrigger>
            </TabsList>

            <TabsContent value="curl">
              <div className="relative">
                <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
                  {curlExample}
                </pre>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => copyToClipboard(curlExample, 'curl')}
                  className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
                >
                  {copied === 'curl' ? <Check size={16} /> : <Copy size={16} />}
                </Button>
              </div>
            </TabsContent>

            <TabsContent value="python">
              <div className="relative">
                <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
                  {pythonExample}
                </pre>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => copyToClipboard(pythonExample, 'python')}
                  className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
                >
                  {copied === 'python' ? <Check size={16} /> : <Copy size={16} />}
                </Button>
              </div>
            </TabsContent>

            <TabsContent value="javascript">
              <div className="relative">
                <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
                  {javascriptExample}
                </pre>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => copyToClipboard(javascriptExample, 'javascript')}
                  className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
                >
                  {copied === 'javascript' ? <Check size={16} /> : <Copy size={16} />}
                </Button>
              </div>
            </TabsContent>

            <TabsContent value="php">
              <div className="relative">
                <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
                  {phpExample}
                </pre>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => copyToClipboard(phpExample, 'php')}
                  className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
                >
                  {copied === 'php' ? <Check size={16} /> : <Copy size={16} />}
                </Button>
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>

      {/* Rate Limits */}
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle>Rate Limits & Best Practices</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2 text-gray-700">
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-1">•</span>
              <span>Pastikan WhatsApp Anda terhubung sebelum mengirim pesan</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-1">•</span>
              <span>Format nomor harus 628xxx (kode negara Indonesia tanpa +)</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-1">•</span>
              <span>Simpan API key dengan aman, jangan share ke publik</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-1">•</span>
              <span>Implementasikan error handling untuk request yang gagal</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-600 mt-1">•</span>
              <span>Gunakan webhook untuk menerima pesan masuk secara real-time</span>
            </li>
          </ul>
        </CardContent>
      </Card>

      {/* Additional Public APIs */}
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Code className="text-green-600" size={24} />
            Additional Public APIs
          </CardTitle>
          <CardDescription>
            Advanced API endpoints untuk integrasi lebih lengkap
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          
          {/* Register User API (Superadmin) */}
          <div>
            <h4 className="font-semibold text-lg mb-2 text-gray-800">1. Register User via API (Superadmin Only)</h4>
            <div className="bg-gray-900 text-green-400 p-3 rounded-lg font-mono text-sm mb-2">
              POST {API}/public/register-user
            </div>
            <p className="text-sm text-gray-600 mb-3">
              Membuat user baru melalui API. Memerlukan Superadmin API Key.
            </p>
            <div>
              <p className="font-semibold text-sm mb-2">Request Body:</p>
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "name": "New User Name",
  "email": "user@example.com",
  "password": "password123",
  "role": "user",
  "superadminApiKey": "YOUR_SUPERADMIN_API_KEY"
}`}
              </pre>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-sm mb-2">Response:</p>
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "success": true,
  "message": "User registered successfully",
  "user": {
    "id": "user-id",
    "email": "user@example.com",
    "name": "New User Name",
    "role": "user",
    "apiKey": "generated-api-key"
  }
}`}
              </pre>
            </div>
          </div>

          {/* Get QR Code API */}
          <div className="border-t pt-6">
            <h4 className="font-semibold text-lg mb-2 text-gray-800">2. Get QR Code (User API Key)</h4>
            <div className="bg-gray-900 text-green-400 p-3 rounded-lg font-mono text-sm mb-2">
              POST {API}/public/qr-code
            </div>
            <p className="text-sm text-gray-600 mb-3">
              Mendapatkan QR code untuk scan WhatsApp jika user belum terhubung.
            </p>
            <div>
              <p className="font-semibold text-sm mb-2">Request Body:</p>
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "apiKey": "YOUR_USER_API_KEY"
}`}
              </pre>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-sm mb-2">Response (Not Connected):</p>
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "success": true,
  "connected": false,
  "status": "qr",
  "qr": "data:image/png;base64,iVBORw0KG...",
  "message": "Scan QR code to connect WhatsApp"
}`}
              </pre>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-sm mb-2">Response (Already Connected):</p>
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "success": true,
  "connected": true,
  "message": "WhatsApp already connected"
}`}
              </pre>
            </div>
          </div>

          {/* Check Connection Status API */}
          <div className="border-t pt-6">
            <h4 className="font-semibold text-lg mb-2 text-gray-800">3. Check Connection Status (User API Key)</h4>
            <div className="bg-gray-900 text-green-400 p-3 rounded-lg font-mono text-sm mb-2">
              POST {API}/public/connection-status
            </div>
            <p className="text-sm text-gray-600 mb-3">
              Cek status koneksi WhatsApp user berdasarkan API Key.
            </p>
            <div>
              <p className="font-semibold text-sm mb-2">Request Body:</p>
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "apiKey": "YOUR_USER_API_KEY"
}`}
              </pre>
            </div>
            <div className="mt-3">
              <p className="font-semibold text-sm mb-2">Response:</p>
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`{
  "success": true,
  "userId": "user-id",
  "userName": "User Name",
  "email": "user@example.com",
  "connected": true,
  "status": "connected",
  "message": "WhatsApp is connected"
}`}
              </pre>
            </div>
          </div>

          {/* cURL Examples */}
          <div className="border-t pt-6">
            <h4 className="font-semibold text-lg mb-2 text-gray-800">cURL Examples</h4>
            
            <div className="space-y-4">
              <div>
                <p className="font-semibold text-sm mb-2">Register User (Superadmin):</p>
                <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`curl -X POST "${API}/public/register-user" \\
  -H "Content-Type: application/json" \\
  -d '{
    "name": "New User",
    "email": "user@example.com",
    "password": "password123",
    "role": "user",
    "superadminApiKey": "YOUR_SUPERADMIN_API_KEY"
  }'`}
                </pre>
              </div>

              <div>
                <p className="font-semibold text-sm mb-2">Get QR Code:</p>
                <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`curl -X POST "${API}/public/qr-code" \\
  -H "Content-Type: application/json" \\
  -d '{"apiKey": "YOUR_USER_API_KEY"}'`}
                </pre>
              </div>

              <div>
                <p className="font-semibold text-sm mb-2">Check Connection Status:</p>
                <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`curl -X POST "${API}/public/connection-status" \\
  -H "Content-Type: application/json" \\
  -d '{"apiKey": "YOUR_USER_API_KEY"}'`}
                </pre>
              </div>
            </div>
          </div>

        </CardContent>
      </Card>

      {/* WebSocket Documentation */}
      <Card className="glass-effect">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Code className="text-green-600" size={24} />
            WebSocket Real-Time Integration
          </CardTitle>
          <CardDescription>
            Gunakan WebSocket untuk menerima update real-time (QR code, status koneksi, pesan masuk)
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* WebSocket Endpoint */}
          <div>
            <h4 className="font-semibold mb-2">WebSocket Server:</h4>
            <div className="bg-gray-900 text-green-400 p-3 rounded-lg font-mono text-sm">
              {WA_SERVICE_URL.replace('https', 'wss').replace('http', 'ws')}
            </div>
            <p className="text-sm text-gray-600 mt-2">
              Untuk production, gunakan URL yang sesuai dengan deployment Anda
            </p>
          </div>

          {/* Installation */}
          <div>
            <h4 className="font-semibold mb-2">Installation:</h4>
            <div className="bg-gray-900 text-green-400 p-3 rounded-lg font-mono text-sm">
              npm install socket.io-client
            </div>
          </div>

          {/* Connection Code */}
          <div>
            <h4 className="font-semibold mb-2">Connect to WebSocket:</h4>
            <Tabs defaultValue="javascript">
              <TabsList>
                <TabsTrigger value="javascript">JavaScript</TabsTrigger>
                <TabsTrigger value="react">React</TabsTrigger>
                <TabsTrigger value="python">Python</TabsTrigger>
              </TabsList>

              <TabsContent value="javascript">
                <div className="relative">
                  <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`const io = require('socket.io-client');

const socket = io('http://localhost:3001');

// Join room dengan userId
socket.emit('join', { userId: 'your-user-id' });

// Listen untuk QR code
socket.on('qr', (data) => {
  console.log('QR Code:', data.qr);
  // Display QR code to user
});

// Listen untuk connection status
socket.on('connection', (data) => {
  console.log('Status:', data.status);
  // 'qr', 'connected', or 'disconnected'
});

// Listen untuk messages
socket.on('message', (data) => {
  console.log('New message:', data);
  // Handle incoming/outgoing message
});`}
                  </pre>
                  <Button
                    size="sm"
                    variant="ghost"
                    onClick={() => copyToClipboard("const io = require('socket.io-client');\n\nconst socket = io('http://localhost:3001');\n\nsocket.emit('join', { userId: 'your-user-id' });\n\nsocket.on('qr', (data) => {\n  console.log('QR Code:', data.qr);\n});\n\nsocket.on('connection', (data) => {\n  console.log('Status:', data.status);\n});\n\nsocket.on('message', (data) => {\n  console.log('New message:', data);\n});", 'ws-js')}
                    className="absolute top-2 right-2 text-green-400 hover:text-green-300 hover:bg-gray-800"
                  >
                    {copied === 'ws-js' ? <Check size={16} /> : <Copy size={16} />}
                  </Button>
                </div>
              </TabsContent>

              <TabsContent value="react">
                <div className="relative">
                  <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`import { useEffect, useState } from 'react';
import io from 'socket.io-client';

function WhatsAppComponent() {
  const [socket, setSocket] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [status, setStatus] = useState('disconnected');
  
  useEffect(() => {
    const newSocket = io('http://localhost:3001');
    setSocket(newSocket);
    
    // Get user from localStorage
    const user = JSON.parse(localStorage.getItem('user'));
    newSocket.emit('join', { userId: user.id });
    
    newSocket.on('qr', (data) => {
      setQrCode(data.qr);
    });
    
    newSocket.on('connection', (data) => {
      setStatus(data.status);
    });
    
    newSocket.on('message', (data) => {
      console.log('New message:', data);
    });
    
    return () => newSocket.disconnect();
  }, []);
  
  return (
    <div>
      {qrCode && <img src={qrCode} alt="QR" />}
      <p>Status: {status}</p>
    </div>
  );
}`}
                  </pre>
                </div>
              </TabsContent>

              <TabsContent value="python">
                <div className="relative">
                  <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-sm">
{`import socketio

sio = socketio.Client()

@sio.on('qr')
def on_qr(data):
    print('QR Code:', data['qr'])

@sio.on('connection')
def on_connection(data):
    print('Status:', data['status'])

@sio.on('message')
def on_message(data):
    print('New message:', data)

sio.connect('http://localhost:3001')
sio.emit('join', {'userId': 'your-user-id'})

# Keep connection alive
sio.wait()`}
                  </pre>
                </div>
              </TabsContent>
            </Tabs>
          </div>

          {/* Events Documentation */}
          <div>
            <h4 className="font-semibold mb-3">WebSocket Events:</h4>
            
            {/* Emit Events */}
            <div className="mb-4">
              <h5 className="font-semibold text-sm text-gray-700 mb-2">Emit (Client → Server):</h5>
              <div className="bg-gray-50 p-4 rounded-lg border space-y-3">
                <div>
                  <code className="text-blue-600 font-mono">join</code>
                  <p className="text-sm text-gray-600 mt-1">Join user-specific room untuk receive updates</p>
                  <pre className="bg-white p-2 rounded mt-1 text-xs">{`{ userId: "user-id-here" }`}</pre>
                </div>
              </div>
            </div>

            {/* Listen Events */}
            <div>
              <h5 className="font-semibold text-sm text-gray-700 mb-2">Listen (Server → Client):</h5>
              <div className="bg-gray-50 p-4 rounded-lg border space-y-3">
                <div>
                  <code className="text-purple-600 font-mono">qr</code>
                  <p className="text-sm text-gray-600 mt-1">QR code untuk scan WhatsApp</p>
                  <pre className="bg-white p-2 rounded mt-1 text-xs overflow-x-auto">
{`{
  qr: "data:image/png;base64,iVBORw0KG..."
}`}
                  </pre>
                </div>

                <div>
                  <code className="text-purple-600 font-mono">connection</code>
                  <p className="text-sm text-gray-600 mt-1">Status koneksi WhatsApp</p>
                  <pre className="bg-white p-2 rounded mt-1 text-xs">
{`{
  status: "connected" | "disconnected" | "qr"
}`}
                  </pre>
                </div>

                <div>
                  <code className="text-purple-600 font-mono">message</code>
                  <p className="text-sm text-gray-600 mt-1">Pesan baru (incoming/outgoing)</p>
                  <pre className="bg-white p-2 rounded mt-1 text-xs overflow-x-auto">
{`{
  userId: "user-id",
  id: "message-id",
  type: "sent" | "received",
  content: "Message text",
  from: "628xxx@s.whatsapp.net",
  fromName: "John Doe",
  mediaType: "text" | "image" | "document",
  mediaUrl: "/media/file-id",
  timestamp: "2024-01-01T00:00:00Z"
}`}
                  </pre>
                </div>
              </div>
            </div>
          </div>

          {/* Use Cases */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-semibold text-blue-900 mb-2">Use Cases WebSocket:</h4>
            <ul className="space-y-1 text-sm text-blue-800">
              <li>✓ Real-time QR code updates</li>
              <li>✓ Instant connection status monitoring</li>
              <li>✓ Live incoming message notifications</li>
              <li>✓ Real-time message delivery status</li>
              <li>✓ Multi-device synchronization</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ApiDocsPage;
